import { createSelector } from "reselect";

export const sourceSelector = createSelector(
    state => state.services.source,
    state => state
);